import React from "react";
import { Container } from "react-bootstrap";
import Breadcrumb from "../../components/common/Breadcrumb";
import { Icon } from "@iconify/react";
import { colors } from "../../components/common/element/elements";
import Heading from "../../components/shared/Heading";
import { ScholarshipSection, ScholarshipWrapper } from "./styles";

const addressList = [
  {
    city: "Tashkent region",
    school:
      "« Tashkent Pharma Park » Innovation Research-Industrial Pharmaceutical Cluster",
    location: "https://maps.app.goo.gl/AkiK2KyXn6g1A38M7",
  },
  {
    city: "Jizzakh city",
    school: "Specialized boarding school No.3",
    location: "https://maps.app.goo.gl/KKCaerZ8tiv16V6H9",
  },
  {
    city: "Navoi region",
    school:
      "Navoi region, Uchquduq District, Xalqlar do’stligi street 59, State Education School No.7 – Location",
    location: "https://maps.app.goo.gl/TNwXCHNDiKAy8sdJ8",
  },
  {
    city: "Andijan city",
    school: "Academic Lyceum of Andijan State University",
    location: "https://maps.app.goo.gl/eV4Bkhat9G5T1uE89",
  },
  {
    city: "Urganch city",
    school: "Specialized boarding school No.1",
    location: "https://maps.app.goo.gl/NdDm5Yq1Q1rdpnbh8",
  },
  {
    city: "Termiz city",
    school: "Specialized school No.3",
    location: "https://maps.app.goo.gl/TNipHu9ujaaobgVRA",
  },
];

const registerSteps = [
  "Read an email sent to you from PTU Admission Office to your email that your registered upon your application. Your unique Application ID is listed in that email—keep it handy for the next step.",
  "Click the given link below. During registration, please select a place that will be convenient for your visit for the exam.",
  "Please note that you can choose and visit PTU at “Tashkent Pharma Park” Cluster for your exam. PTU team will be pleased to welcome you.",
];

const ScholarshipExam = () => {
  return (
    <>
      <Breadcrumb
        title="Scholarship Exam"
        previousPath="/scholarship"
        image={"/assets/images/scholarship_exam.webp"}
        previousTitle="PIDA Scholarships"
      />

      <Container>
        <ScholarshipWrapper>
          <ScholarshipSection>
            <Heading
              tag="h5"
              title="Ready to compete for a Scholarship to study at PTU?"
              className="strategy-title mb-3"
            />
            <p>
              The Scholarship Exam will be held on
              <b> Wednesday, 25 June 2025</b> in the following venues:
            </p>
            <ul className="list-unstyled">
              {addressList.map((address, index) => (
                <li className="d-flex mb-3 item" key={index}>
                  <Icon
                    icon="ph:map-pin-duotone"
                    fontSize={24}
                    color={colors.bg2}
                  />
                  <b>{address.city},</b> {address.school} –
                  {address.school && <a href={address.location}>Location</a>}
                </li>
              ))}
            </ul>
          </ScholarshipSection>
          <ScholarshipSection>
            <Heading
              tag="h5"
              title="You must register for the Scholarship Exam as follows:"
              className="strategy-title mb-3"
            />
            <ol className="list-unstyled">
              {registerSteps.map((step, index) => (
                <li className="d-flex gap-3 mb-3 item" key={index}>
                  <b>{index + 1}.</b> {step}
                </li>
              ))}
            </ol>
            <p>
              <b>👉 Register here: </b>
              <a
                href="https://forms.office.com/r/WNa4Hba0dc"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://forms.office.com/r/WNa4Hba0dc
              </a>
            </p>
            <p>
              After you register, we’ll email you the exact address, reporting
              time, and exam day instructions.
            </p>
            <Heading
              tag="h5"
              title="Mind English-language certificate deadline"
              className="strategy-title mb-3"
            />
            <p>
              You must email a scanned copy your{" "}
              <b>
                IELTS or other equivalent internationally recognised certificate{" "}
              </b>
              to{" "}
              <a href="mailto:admissions@pharmatechuni.uz">
                admissions@pharmatechuni.uz
              </a>{" "}
              <b>no later than 30 June 2025.</b> Certificates received after
              this deadline are not eligible for a scholarship.
            </p>
            <p>
              Need assistance? <br /> Email{" "}
              <a href="mailto:admissions@pharmatechuni.uz">
                admissions@pharmatechuni.uz
              </a>{" "}
              or call <a href="tel:+998559000500">+998 55 900 05 00</a>.
            </p>
            <p>Good luck, and we look forward to seeing you on 25 June!</p>
          </ScholarshipSection>
        </ScholarshipWrapper>
      </Container>
    </>
  );
};

export default ScholarshipExam;
